// Vendor imports
const Cookies = require('js-cookie')
// Client V1 libs
const cookieLib = require('client/lib/cookie')
// Client V2 common imports
const extension = require('client-v2/common/utils/extension')

// Action types

const UPDATE_EXTENSION_INSTALLED = 'ENVIRONMENT_UPDATE_EXTENSION_INSTALLED'

// Action dispatchers

function checkForExtension() {
  return function (dispatch, getState) {
    const wasInstalled = getState().env.extensionInstalled
    const isInstalled = extension.isInstalled()
    if (isInstalled && !Cookies.get('mix-ext')) {
      Cookies.set('mix-ext', '1', cookieLib.setAttributes('mix-ext'))
    } else if (!isInstalled) {
      Cookies.remove('mix-ext', cookieLib.clearAttributes('mix-ext'))
    }
    if (wasInstalled !== isInstalled) {
      dispatch({
        type: UPDATE_EXTENSION_INSTALLED,
        payload: isInstalled
      })
    }
  }
}

module.exports = {
  // Action types
  UPDATE_EXTENSION_INSTALLED,
  // Action dispatchers
  checkForExtension
}
